export enum SmsStatusEnum {
  PENDING = "pending",
  VALIDATED = "validated",
}

export const getValidSmsStatus = (): string[] => {
  return Object.values(SmsStatusEnum);
};

export const isValidSmsStatus = (value: string): value is SmsStatusEnum => {
  return Object.values(SmsStatusEnum).includes(value as SmsStatusEnum);
};

export const mapSmsStatusToVerificationStatus = (
  status: string | null | undefined
): "none" | "pending" | "verified" | "expired" => {
  if (!status) return "none";

  switch (status.toLowerCase()) {
    case SmsStatusEnum.VALIDATED:
      return "verified";
    case SmsStatusEnum.PENDING:
      return "pending";
    default:
      return "none";
  }
};
